<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Equipamentos</h3>
        <d-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-equipment-new' }"
        >
          Novo equipamento
        </d-link>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex justify-content-around">
            <div class="col-6">
              <h6 class="m-0">Equipamentos Ativos</h6>
            </div>
            <div class="col-6">
              <form class="main-sidebar__search w-100 d-flex">
                <div class="input-group input-group-seamless ml-3">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <i class="fas fa-search"></i>
                    </div>
                  </div>
                  <input
                    class="navbar-search form-control"
                    type="text"
                    placeholder="Procurar por algo..."
                    aria-label="Search"
                    v-model="pagination.search"
                  />
                </div>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <equipment-table :equipments="equipments.list" />
            </div>
            <pagination
              :total-items="equipments.total_items"
              :pagination.sync="pagination"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão do Equipamento"
      message="Tem certeza que deseja excluir esse equipamento?"
    />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import EquipmentTable from '../components/EquipmentListTable.vue';
import EquipmentDelete from '../components/EquipmentDelete';

export default {
  name: 'equipment-list',
  mixins: [EquipmentDelete],
  components: {
    Pagination,
    EquipmentTable,
    ConfirmationModal,
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    equipments() {
      const { equipmentList } = this.$store.state.equipment;
      if (equipmentList && equipmentList.list && equipmentList.list.length) {
        return equipmentList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions(['setToggle', 'getEquipmentList']),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getEquipmentList(this.pagination).then(() => {
        this.setToggle({ type: 'progress', bool: false });
      });
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },
  beforeDestroy() {
    Events.$off('update:pagination');
  },
};
</script>
